<script lang="ts">
    import { LocalDate } from "@/time";

    export let date;
    export let planReports = null;
    // The athlete's username when a coach is viewing their calendar.
    export let username = null;

    $: report = planReports ? planReports[LocalDate.format(date)] : null;
    $: href = report ? `/plan-report/${report.plan_id}` + (username ? `?forUser=${encodeURIComponent(username)}` : '') : null;
</script>

{#if report}
    <a {href} class="block rounded-sm bg-white border border-solid border-zinc-200 px-2 py-1.5 text-left text-xs text-zinc-700 no-underline hover:bg-zinc-50" title={report.headline_text ?? undefined}>
        <div class="flex items-center gap-1.5">
            <i class="fa-thin fa-lg fa-trophy" style="font-size: 16px;" />
            <span class="rounded-sm bg-green-100 text-green-800 px-1.5 py-px text-[10px] font-medium">Plan completed</span>
            {#if !report.viewed}<span class="rounded-full w-2 h-2 bg-blue-500 ml-auto" title="New" />{/if}
        </div>
        <div class="mt-1 font-medium">Training report</div>
        <div class="text-zinc-500 leading-snug">{report.headline_text ?? 'See how your plan went.'}</div>
        <div class="mt-0.5 text-blue-600">View your results →</div>
        <div class="mt-1 text-[10px] text-zinc-400 leading-snug">No more forecasted activities. You are now in Continuous mode.</div>
    </a>
{/if}
